module.exports = __webpack_public_path__ + "static/media/ptc-therapeutics.167f7030.png";